import { formatMoney } from "./formatters";

export function probabilityTooltip(value) {
  return [`${Number(value).toFixed(2)}%`, "Probability"];
}

export function lossLabelFormatter(value, currency = "USD") {
  return `Loss: ${formatMoney(value, currency)}`;
}

export function investmentLabelFormatter(value, currency = "USD") {
  return `Investment: ${formatMoney(value, currency)}`;
}